import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { useLenis } from "@/lib/useLenis";
import { CalendlyProvider } from "@/components/CalendlyContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { NoiseOverlay } from "@/components/NoiseOverlay";
import { ScrollToTop } from "@/components/ScrollToTop";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";
import { CookieConsent } from "@/components/CookieConsent";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import About from "@/pages/About";
import Work from "@/pages/Work";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

function AppShell() {
  useLenis();

  return (
    <BrowserRouter>
      <CalendlyProvider>
        <NoiseOverlay />
        <ScrollToTop />
        <Navbar />
        <main className="relative bg-[#050505] min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/about" element={<About />} />
            <Route path="/work" element={<Work />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-of-service" element={<Terms />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <StickyMobileCTA />
        <CookieConsent />
        <Toaster theme="dark" position="bottom-right" />
      </CalendlyProvider>
    </BrowserRouter>
  );
}

function App() {
  return <AppShell />;
}

export default App;
